module.exports = __webpack_public_path__ + "static/media/image-3.4cc9ec9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/image-3.jpg
// module id = 12
// module chunks = 0